// extracted by mini-css-extract-plugin
export default {"ios":"styles_ios__7fAIt"};